import styled from "styled-components";

const PlayIconWrapper = styled.svg`
    width: 22px;
    fill: grey;
    &:hover path {
      fill: var(--color-brand-pink-primary);;
    }
`;



const PlayIcon = () => {
  return(
      <PlayIconWrapper xmlns="http://www.w3.org/2000/svg" className="st0" viewBox="0 0 22 22.001" >
          <g className="st1">
	<path className="st2" d="M4.6,7.6c0-3.7,3-6.8,6.8-6.8c3.7,0,6.8,3,6.8,6.8s-3,6.8-6.8,6.8C7.7,14.4,4.6,11.3,4.6,7.6z M11.4,13.5
		c3.3,0,5.9-2.7,5.9-5.9c0-3.3-2.7-5.9-5.9-5.9c-3.3,0-5.9,2.7-5.9,5.9C5.5,10.9,8.2,13.5,11.4,13.5z M14.6,8.2L9.8,11
		c-0.4,0.2-1-0.1-1-0.6V4.7c0-0.5,0.5-0.8,1-0.6l4.8,2.9C15,7.3,15,8,14.6,8.2z M9.9,9.9l3.7-2.1c0.1-0.1,0.1-0.2,0-0.3L9.9,5.3
		c-0.1-0.1-0.2,0-0.2,0.1v4.3C9.6,9.9,9.8,10,9.9,9.9z"/>
</g>
</PlayIconWrapper>
  );
}

export default PlayIcon;
